<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  data() {
    return {
      intervalChart: "",
      dataLabels: Array,
      dataValues: Array
    };
  },
  props: {
    label: {
      type: String,
    },
    chartData: {
      type: Object,
    },
  },
  methods: {
    makeChart() {
        const unitMeasure = this.chartData.shortUnitMeasure;
        const scaleToShow = this.chartData.scaleToShow;
        //console.log(this.chartData.valueName)
        //this.dataLabels = this.chartData.allData.map(t => t[this.chartData.valueName.toString()].substring(5, 10) + "/" + t[this.chartData.valueName.toString()].substring(11, 16));
        this.dataLabels = this.chartData.allData.map(t => t[this.chartData.valueName.toString()].substring(0, 19));
        if (unitMeasure == "%") {
            this.dataValues = this.chartData.allData.map(t => t.humedad);
        } else if (unitMeasure == "°C") {
            this.dataValues = this.chartData.allData.map(t => t.temp_status);
        } else {
          this.dataValues = this.chartData.allData.map(t => t.eth_status);
        }

        this.renderChart(
        {
          labels: this.dataLabels, 
          datasets: [
            {
              /* label: this.label,
              data: this.dataValues,
              borderColor: this.chartData.colorHex,
              backgroundColor: this.chartData.colorRGB,
              fill: true,
              pointStyle: 'line' */
              label: this.label,
              data: this.dataValues,
              fill: true,
              fillColor: 'pink',
              backgroundColor: 'rgba(255,255,255,0)',
              borderColor: this.chartData.colorHex,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.5,
              pointBackgroundColor: this.chartData.colorHex,
              pointBorderColor: 'rgba(255,255,255,0)',
              pointHoverBackgroundColor: this.chartData.colorHex,
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 1,
            },
          ],
        },
        {
          maintainAspectRatio: false,
          animation: {
            duration: 0, // general animation time
          },
          hover: {
            animationDuration: 0, // duration of animations when hovering an item
          },
          responsiveAnimationDuration: 0,
          responsive: true,
          elements: {
            line: {
              tension: 0.1,
            },
          },
          /* legend: {
            labels: {
              fontColor: "#fcfcfa",
            },
          }, */
          legend: {
            display: false
          },
          scales: {
            xAxes: [
              {
                gridLines: {
                  drawBorder: false,
                  color: "rgba(0,242,195,0.1)",
                  zeroLineColor: "transparent",
                },
                ticks: {
                  padding: 5,
                  fontColor: "rgb(153, 151, 151)"
                },
                offset: false,
                type: 'time',
                time: {
                  unit: scaleToShow
                }
              },
            ],
            yAxes: [
              {
                /* scaleLabel: {
                  display: true,
                  fontColor:  "#fcfcfa",
                  labelString:
                    this.label +
                    " (" +
                    this.chartData.shortUnitMeasure +
                    ")",
                }, */
                gridLines: {
                  drawBorder: false,
                  color: "rgba(29,140,248,0.0)",
                  zeroLineColor: "transparent",
                },
                ticks: {
                  fontColor: "rgb(153, 151, 151)",
                  //beginAtZero: false,
                  padding: 5,
                  callback: function (value) {
                    return value + " " + unitMeasure ;
                  },

                },
              },
            ],
          },
          title: {
            display: false
          },
          tooltips: {
            /* enable: true,
            mode: "single",
            callbacks: {
              title: function (tooltipItems) {
                return "Hora: " + tooltipItems[0].xLabel;
              },
            }, */
            backgroundColor: "#f5f5f5",
            titleFontColor: "#333",
            bodyFontColor: "#666",
            bodySpacing: 4,
            xPadding: 12,
            intersect: 0,
            position: "nearest",
            mode: "nearest",
            enable: true,
            callbacks: {
              title: function (tooltipItems) {
                return tooltipItems[0].xLabel;
              },
            },
          },
        }
      );
    },

    callDataChartEvery() {
      this.intervalChart = window.setInterval(
        function () {
          this.makeChart();
        }.bind(this),
        3000
      );
    },
  },
  mounted() {
    this.callDataChartEvery();
    this.makeChart();
  },
  beforeDestroy() {
    clearInterval(this.intervalChart);
  },
};
</script>
